import { render, staticRenderFns } from "./AutoRobotMonitor.vue?vue&type=template&id=03a616d8&scoped=true&"
import script from "./AutoRobotMonitor.vue?vue&type=script&lang=js&"
export * from "./AutoRobotMonitor.vue?vue&type=script&lang=js&"
import style0 from "./AutoRobotMonitor.vue?vue&type=style&index=0&id=03a616d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a616d8",
  null
  
)

export default component.exports